import { render, staticRenderFns } from "./SieHomeBtn.vue?vue&type=template&id=5abe5151"
import script from "./SieHomeBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./SieHomeBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports